// Cookie Policy - Arabic version (RTL)

export const cookieContentAR = {
  title: 'سياسة ملفات تعريف الارتباط',
  lastUpdated: 'آخر تحديث: 06.11.2025',
  
  sections: [
    {
      id: 'what-are-cookies',
      title: '1. ما هي ملفات تعريف الارتباط؟',
      content: 'ملفات تعريف الارتباط هي ملفات نصية صغيرة تحفظها مواقع الويب على جهازك لتحسين تجربة المستخدم وتحليل حركة المرور على الويب. لا تضر ملفات تعريف الارتباط بجهازك ولا تحتوي على فيروسات.'
    },
    {
      id: 'types',
      title: '2. ما ملفات تعريف الارتباط التي نستخدمها؟',
      types: [
        {
          name: 'ملفات تعريف الارتباط الضرورية',
          description: 'هذه ملفات تعريف الارتباط ضرورية لعمل الموقع ولا يمكن تعطيلها.',
          items: ['إدارة الجلسة', 'الأمان والمصادقة', 'تخزين بيانات النموذج'],
          retention: 'حتى نهاية الجلسة'
        },
        {
          name: 'ملفات تعريف الارتباط التحليلية',
          description: 'تساعدنا على فهم كيفية استخدام الزوار للموقع.',
          items: [
            { name: 'Google Analytics 4', description: 'تحليل حركة المرور وسلوك المستخدم' },
            { name: 'Hotjar', description: 'تحليل تجربة المستخدم والخرائط الحرارية' }
          ],
          retention: 'حتى سنتين',
          privacy: 'https://policies.google.com/privacy'
        },
        {
          name: 'ملفات تعريف الارتباط التسويقية',
          description: 'تُستخدم للإعلانات الموجهة وإعادة الاستهداف.',
          items: [
            { name: 'Facebook Pixel', description: 'تحسين الإعلانات وإعادة الاستهداف' }
          ],
          retention: 'حتى سنتين',
          privacy: 'https://www.facebook.com/privacy/policy'
        },
        {
          name: 'ملفات تعريف الارتباط الوظيفية',
          description: 'توفر ميزات متقدمة وتخصيصًا شخصيًا.',
          items: [
            { name: 'أداة ChatGPT', description: 'مساعد AI' },
            'حفظ اللغة والتفضيلات'
          ],
          retention: 'حتى سنة واحدة'
        }
      ]
    },
    {
      id: 'manage',
      title: '3. كيف تدير ملفات تعريف الارتباط؟',
      content: 'يمكنك إدارة ملفات تعريف الارتباط من خلال إعداداتنا أو من خلال إعدادات متصفحك. يرجى ملاحظة أن تعطيل ملفات تعريف الارتباط قد يؤثر على وظائف الموقع.',
      buttonText: 'فتح إعدادات ملفات تعريف الارتباط'
    },
    {
      id: 'legal',
      title: '4. الأساس القانوني',
      intro: 'يستند استخدام ملفات تعريف الارتباط إلى:',
      items: [
        'اللائحة العامة لحماية البيانات (GDPR)',
        'قانون الاتصالات الإلكترونية الإستوني § 104',
        'موافقتك (باستثناء ملفات تعريف الارتباط الضرورية)'
      ]
    },
    {
      id: 'contact',
      title: '5. الاتصال',
      intro: 'للأسئلة المتعلقة بملفات تعريف الارتباط، يرجى الاتصال بنا:',
      company: 'Polyus Plus OÜ',
      address: 'Uuslinna 11, Tallinn, Estonia',
      linkText: 'اتصل عبر نموذج الاتصال'
    }
  ]
};
